import React from 'react'
import { Link } from "react-router-dom";


export const COLUMN_DEFINITIONS = [
    {
        id: "id",
        header: "ID",
        cell: item => item.id
    },
    {
        id: "version_number",
        header: "Version Number",
        cell: item => <Link to={`/contracts/${item.id}`}>{item.versionNumber}</Link>
    },
    {
        id: "created_at",
        header: "Created",
        cell: item => item.createdAt
    },
    {
        id: "updated_at",
        header: "Updated",
        cell: item => item.updatedAt
    },
    {
        id: "active",
        header: "Active",
        cell: item => item.active
    }
]

export const LOADING_TEXT = "Loading contracts"

export const BREADCRUMB_ITEMS = [
    {
      "text": "Contracts",
      "href": "/"
    }
]


// WEBPACK FOOTER //
// ./src/components/Contracts/List/ContractsListConstants.jsx